<template>
  <div class="swiper_box" v-if="swiperArr && swiperArr.length > 0">
    <div class="swiper-container" ref="swiperContainerRef">
      <ul class="swiper-wrapper">
        <li
          class="swiper-slide"
          v-for="(item, index) in swiperArr"
          :key="index"
        >
          <div class="banner_img">
            <img :src="item.pic" alt="" />
          </div>
        </li>
      </ul>
      <div
        class="swiper-pagination"
        ref="paginationRef"
        v-if="swiperArr && swiperArr.length > 1"
      ></div> 
    </div>
      <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed"></WxOpenAppItm>
  </div>
</template>
<script setup lang="ts">
import { appInfo } from "@eastmoney/mku";
import {
  defineAsyncComponent,
  nextTick,
  onBeforeUnmount,
  ref,
  watch,
} from "vue";
import { storeToRefs } from "pinia";
import { useMainStore } from "@/pinia/main";
const store = useMainStore();
const { hasAuth } = storeToRefs(store);

const WxOpenAppItm = defineAsyncComponent(() =>
  import("@/components/WxOpenAppItm.vue").then(
    (module: any) => module.default || module
  )
);

type BannerItem = {
  pic: string;
  iosLink?: string;
  androidLink?: string;
};

const props = withDefaults(
  defineProps<{
    swiperArr?: BannerItem[];
  }>(),
  {
    swiperArr: () => [],
  }
);

 
const swiperArr = ref<BannerItem[]>([]);
const swiper = ref<any>(null);
const swiperContainerRef = ref<HTMLElement | null>(null);
const paginationRef = ref<HTMLElement | null>(null);

const initSwiperMed = () => {
  const SwiperClass = (window as any).Swiper;
  if (!SwiperClass || !swiperContainerRef.value) {
    return;
  }

  if (swiper.value?.destroy) {
    swiper.value.destroy(false);
  }

  const hasMultiple =
    Array.isArray(swiperArr.value) && swiperArr.value.length > 1;

  swiper.value = new SwiperClass(swiperContainerRef.value, {
    autoplay: hasMultiple
      ? {
          disableOnInteraction: false,
          delay: 3000,
        }
      : false,
    loop: hasMultiple,
    allowTouchMove: hasMultiple,
    pagination: {
      el: paginationRef.value,
    },
    on: {
      tap: function (this: any, e: any) {
        try {
          const slideEl =
            (this.clickedSlide as HTMLElement | null) ||
            (e?.target?.closest?.(".swiper-slide") as HTMLElement | null);
          if (!slideEl) {
            return;
          }

          const dataIndex = slideEl.getAttribute?.("data-swiper-slide-index");
          const parsedIndex =
            dataIndex !== null && dataIndex !== undefined
              ? parseInt(dataIndex, 10)
              : this.clickedIndex || 0;
          const bannerIndex = Number.isNaN(parsedIndex) ? 0 : parsedIndex;

          const item = swiperArr.value?.[bannerIndex];
          if (!item) {
            return;
          }

          const target = (e?.target || slideEl) as HTMLElement;
          if (target.closest && target.closest(".banner_img")) {
            handleSideBanner(item);
          }
        } catch (err) {
          console.error("swiper tap handler error", err);
        }
      },
    },
  });
};

watch(
  () => props.swiperArr,
  async (newSwiperArr) => {
    swiperArr.value = Array.isArray(newSwiperArr) ? newSwiperArr : [];
    if (swiperArr.value.length > 0) {
      await nextTick();
      initSwiperMed();
    }
  },
  { immediate: true, deep: true }
);

onBeforeUnmount(() => {
  if (swiper.value?.destroy) {
    swiper.value.destroy(false);
  }
});

const handleSideBanner = (item: BannerItem) => {
  appInfo.inApp(
    () => {
      // 在app中
      if (appInfo.isIOS) {
        window.location.href = item.iosLink || "";
      } else {
        window.location.href = item.androidLink || "";
      }
    },
    () => {
      // 在app外
      linkAppMed();
    }
  );
};

const linkAppMed = () => {
  (window as any).linkAppMed?.();
};
</script>

<style lang="scss" scoped>
.swiper_box {
  position: relative;
  margin-top: 0.24rem;
  display: flex;
  align-items: center;
  .swiper-container {
    position: relative;
    box-sizing: border-box;
    width: 6.9rem;
    height: 1.6rem;
    background-color: #ffffff;
    border-radius: 0.24rem;
    .swiper-wrapper {
      .swiper-slide {
        width: 6.9rem;
        height: 1.6rem;
        .banner_img {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 6.9rem;
          height: 1.6rem;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    --swiper-theme-color: #d1d0ce;
    --swiper-pagination-color: #999895; /* 两种都可以 */
  }
}
</style>


<style lang="scss">
.swiper-pagination-bullets {
  bottom: -0.04rem !important;
  .swiper-pagination-bullet {
    margin: 0 0.08rem !important;
    width: 0.14rem !important;
    height: 0.14rem !important;
    border-radius: 0.14rem !important;
  }
}
</style>